/** Response com os dados de legenda da consulta da Análise de Mercado RAP */
export class ClienteAnaliseMercadoRAPLegendaResponse {
    anoAnterior2: number;
    anoAnterior1: number;
    ano: number;
    customerShareOtimo: number;
    customerShareBom: number;
    customerShareRazoavel: number;

    constructor(props: Partial<ClienteAnaliseMercadoRAPLegendaResponse>) {
        Object.assign(this, props);
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): ClienteAnaliseMercadoRAPLegendaResponse {
        return new ClienteAnaliseMercadoRAPLegendaResponse(JSON.parse(json));
    }
}
